// extracted by mini-css-extract-plugin
export default {"container":"NewsletterItem_container__6x+n3"};